import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

// Basename cho React Router:
// - Localhost dev (yarn start): '/ssd-shared' (subpath)
// - Production hosting: REACT_APP_BASE_PATH=/ để chạy ở root
// CRA chỉ inline các biến REACT_APP_* vào bundle (PUBLIC_URL bị CRA xử lý đặc biệt)
const BASE_PATH = process.env.REACT_APP_BASE_PATH || '/ssd-shared';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <CollapseDrawerProvider>
      <BrowserRouter basename={BASE_PATH}>
        <App />
      </BrowserRouter>
    </CollapseDrawerProvider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more at: https://bit.ly/CRA-vitals
reportWebVitals();
